export function attachAmbientPlayback(
  video: HTMLVideoElement,
  src: string,
  onPlayingChange: (playing: boolean) => void,
) {
  const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let disposed = false;
  let attempt = 0;
  const show = () => onPlayingChange(true);
  const hide = () => onPlayingChange(false);

  const play = () => {
    if (disposed || motion.matches || document.hidden || !video.paused) return;
    // Set both before src: mobile autoplay can inspect the attribute as well
    // as the current muted property.
    video.defaultMuted = true;
    video.muted = true;
    if (!video.getAttribute("src")) video.src = src;
    const currentAttempt = ++attempt;
    void video.play().catch(() => {
      if (!disposed && currentAttempt === attempt) hide();
    });
  };
  const sync = () => {
    if (motion.matches || document.hidden) {
      attempt++;
      video.pause();
      hide();
      if (motion.matches && video.getAttribute("src")) {
        video.removeAttribute("src");
        video.load();
      }
    } else {
      play();
    }
  };

  hide();
  video.addEventListener("playing", show);
  video.addEventListener("pause", hide);
  video.addEventListener("error", hide);
  motion.addEventListener("change", sync);
  document.addEventListener("visibilitychange", sync);
  document.addEventListener("pointerdown", play, { passive: true });
  document.addEventListener("keydown", play);
  sync();

  return () => {
    disposed = true;
    motion.removeEventListener("change", sync);
    document.removeEventListener("visibilitychange", sync);
    document.removeEventListener("pointerdown", play);
    document.removeEventListener("keydown", play);
    video.removeEventListener("playing", show);
    video.removeEventListener("pause", hide);
    video.removeEventListener("error", hide);
    video.pause();
    video.removeAttribute("src");
    video.load();
  };
}
